import React from "react";
import { Status } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const UnavailableStatus = (props) => {
  const { size } = props;

  return <Status data-testid="unavailableStatus" state="error" size={size} />;
};

UnavailableStatus.propTypes = {
  size: PropTypes.string,
};

UnavailableStatus.defaultProps = {
  size: "larger",
};

export default UnavailableStatus;
